import React from 'react';
import { Link } from 'react-router-dom';
import { Segment, Item, Grid, Header, List, Button } from 'semantic-ui-react';
import parse from 'html-react-parser';
//import { deleteApplicationInFirestore } from '../../../app/firestore/firestoreService';
import Stars from '../../../app/common/elements/Stars';
import { Fragment } from 'react';

export default function ApplicationListItem({ application, showAdvanced }) {
  const description = application.short_description
    ? application.short_description
    : application.intro.length > 250
    ? application.intro
        .substring(0, 250)
        .substring(0, application.intro.substring(0, 250).lastIndexOf(' ')) +
      '...'
    : application.intro;

  return (
    <Segment.Group>
      <Segment className='appItem' clearing>
        <Item.Group>
          <Item>
            <Item.Image
              size='small'
              style={{ margin: '0px!important' }}
              src={
                application.photoURL ||
                `https://images.shrinktheweb.com/xino.php?stwembed=1&stwaccesskeyid=6dbdf52c041d58b&stwsize=120x90&stwurl=${application.url}`
              }
              as={Link}
              to={`/view/${application.slug}`}
            />
            <Item.Content>
              <Item.Header
                content={application.title}
                as={Link}
                to={`/view/${application.slug}`}
                style={{ color: '#4183c4' }}
              />
              <Item.Description style={{ marginTop: 0 }}>
                {/* <div>Status: {application.status}</div> */}
                {application.star_rating ? (
                  <span>
                    <Stars starRating={application.star_rating} />
                  </span>
                ) : application.rating_avg > 0 ? (
                  <Fragment>
                    <span style={{ display: 'block' }}>
                      <Stars starRating={application.rating_avg} />
                    </span>
                    <span style={{ marginLeft: '100px', fontSize: '0.7em' }}>
                      {Math.round(application.rating_avg * 10) / 10} / 5 by{' '}
                      {Math.round(application.rating_user)} user
                      {application.rating_user > 1 && 's'}
                    </span>
                  </Fragment>
                ) : (
                  <span>[Not yet rated]</span>
                )}
              </Item.Description>
              <Item.Description>
                Added By:{' '}
                {application.author_name ? (
                  application.author_name === 'admin' ? (
                    'Language Learning Library'
                  ) : (
                    application.author_name
                  )
                ) : (
                  <a href={`/profile/${application.authorId}`}>
                    {application.author}
                  </a>
                )}
              </Item.Description>
              <Item.Description>{parse(description)}</Item.Description>
            </Item.Content>
          </Item>
        </Item.Group>
        <div>
          <Button.Group floated='right'>
            {/*
            <Button
              onClick={() => deleteApplicationInFirestore(application.id)}
              color='red'
              content='Delete'
              floated='right'
            />
            <Button
              as={Link}
              to={`/manage/${application.id}`}
              color='teal'
              content='Edit'
              floated='right'
            />{' '}
            */}
            <Button
              color='blue'
              content='View'
              as={Link}
              to={`/view/${application.slug}`}
              floated='right'
            />
          </Button.Group>
        </div>
      </Segment>
      {showAdvanced && (
        <Segment clearing>
          <Grid>
            <Grid.Row stretched className='appCategories'>
              {application.language && application.language.length > 0 && (
                <Grid.Column computer={5} mobile={16}>
                  <Segment clearing>
                    <Header>Language(s)</Header>
                    <List>
                      {application.language.sort().map((language) => (
                        <List.Item key={language}>{language}</List.Item>
                      ))}
                    </List>
                  </Segment>
                </Grid.Column>
              )}
              {application.level && application.level.length > 0 && (
                <Grid.Column computer={5} mobile={16}>
                  <Segment clearing>
                    <Header>Level(s)</Header>
                    <List>
                      {application.level.map((level) => (
                        <List.Item key={level}>{level}</List.Item>
                      ))}
                    </List>
                  </Segment>
                </Grid.Column>
              )}
              {application.media_type && application.media_type.length > 0 && (
                <Grid.Column computer={6} mobile={16}>
                  <Segment clearing>
                    <Header>Media Type(s)</Header>
                    <List>
                      {application.media_type.map((media_type) => (
                        <List.Item key={media_type}>{media_type}</List.Item>
                      ))}
                    </List>
                  </Segment>
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Segment>
      )}
    </Segment.Group>
  );
}
